import React, { useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Select, { components } from "react-select";
import Search from "../../components/Header/Search/Search";
import Pagination from "../../components/Pagination/Pagination";
import EmptyState from "../../components/EmptyState";
import userRoleAuth from "../../utils/userRoleAuth/userRoleAuth";
import userRoles from "../../config/userRoles";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  useGetLocationList,
  useGetDepartmentList,
  useGetDesignationList,
} from "../../queries/employeeQueries";
import PageLoader from "../../components/PageLoader";
import EmployeePayrollData from "./EmployeePayrollData";
import {
  useGetEmployeePolicyPayrollList,
  useGenerateEmployeePayrollPolicy,
} from "../../queries/payrollQuries";
import { policyPayrollPrcessStatusOptions } from "../../utils/commonSelectBoxOptions/commonSelectBoxOptions";
import { PAYROLL_STATUS } from "../../redux/constants/payrollComponents";
import { useNavigate } from "react-router-dom";
const DropdownIndicator = (props) => (
  <components.DropdownIndicator {...props}>
    <span className="ico-down text-blue-600"></span>
  </components.DropdownIndicator>
);
// get month and year
const EmployeeSalaryPayrollApproval = () => {
  const [searchParams] = useSearchParams();
  const hasPayrollStatusParam = searchParams.get("payroll_status");
  const monthParam = searchParams.get("month");
  const yearParam = searchParams.get("year");
const navigate = useNavigate();
  const selectedMonth = monthParam ? Number(monthParam) : null;
  const selectedYear = yearParam ? Number(yearParam) : null;
  const user = useSelector((state) => state.user.auth);
  const isHr = userRoleAuth(user, userRoles.HR);
  const searchRef = useRef();

  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const [progress, setProgress] = useState(0);
  const [cancelProcessing, setCancelProcessing] = useState(false);
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successCount, setSuccessCount] = useState(0);
  const [failureCount, setFailureCount] = useState(0);
  const [skippedCount, setSkippedCount] = useState(0);


  const [searchFilter, setFilter] = useState({
    page_no: 1,
    page_size: 10,
    filter: "",
    department: "",
    designation: "",
    office: "",
    payroll_status: "",
  });
  const params = {
    ...searchFilter,
    month: selectedMonth || "",
    year: selectedYear || "",
  };

  if (hasPayrollStatusParam) {
    params.payroll_status = PAYROLL_STATUS.PENDING;
  }
  const { data: payrollData, isLoading } =
    useGetEmployeePolicyPayrollList(params);
  const employeeList = Array.isArray(payrollData?.data) ? payrollData.data : [];
  const totalRecords = Number(payrollData?.totalRecords) || 0;
  const totalPages = Number(payrollData?.totalPages) || 1;

  const [selectedDesignation, setSelectedDesignation] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedOffice, setSelectedOffice] = useState(null);
  const [selectedPayrollStatus, setSelectPayrollStatus] = useState(null);

  const defaultLocationOption = { location_name: "Office: All", id: null };
  const defaultDesignationOption = {
    designation_title: "Designation: All",
    id: null,
  };
  const defaultDepartmentOption = {
    department_name: "Department: All",
    id: null,
  };

  const { data: getLocationList } = useGetLocationList();
  const { data: getDepartmentList } = useGetDepartmentList();
  const { data: getDesignationList } = useGetDesignationList();
  const generatePayrollMutation = useGenerateEmployeePayrollPolicy();

  const processPayroll = async () => {
  setIsProcessing(true);
  setShowConfirmModal(false);
  setShowProgressModal(true);
  setProgress(0);
  setCancelProcessing(false);

  const selectedEmpDetails = employeeList?.filter((emp) =>
    selectedEmployees.includes(emp.employee_id)
  );

  let processed = 0;
  let success = 0;
  let failed = 0;
  let skipped = 0; 

  await selectedEmpDetails.reduce(async (prev, emp) => {
    await prev;
    if (cancelProcessing) return;
    if (!emp.payroll_policy_id) {
      skipped++;
      processed++;
      toast.warn(`No payroll policy has been assigned to ${emp.first_name} ${emp.last_name}`);
      setProgress(processed);
      return;
    }
 if (!emp.account_number || emp.account_number.trim() === "") {
    skipped++;
    processed++;
    toast.warn(
      `No bank details available for ${emp.first_name} ${emp.last_name}. Payroll cannot be generated. Please fill in the employee's bank details first.`
    );
    setProgress(processed);
    return;
  } 
    const payload = {
      payroll_policy_id: emp.payroll_policy_id,
      employees: [{ employee_id: emp.employee_id }],
      month: selectedMonth,
      year: selectedYear,
    };

    try {
      const res = await generatePayrollMutation.mutateAsync(payload);
      if (res?.status) {
        success++;
        toast.success(`Payroll generated for ${emp.first_name} ${emp.last_name}`);
      } else {
        failed++;
        toast.error(
          `Failed for ${emp.first_name} ${emp.last_name}: ${
            res?.message || "Unknown error"
          }`
        );
      }
    } catch (err) {
      failed++;
      toast.error(`Error for ${emp.first_name} ${emp.last_name} : ${err?.message}`);
    }

    processed++;
    setProgress(processed);
  }, Promise.resolve());

  setSuccessCount(success);
  setFailureCount(failed);
  setSkippedCount(skipped);

  toast.success("Policy generation is in progress");

  setTimeout(() => {
    setShowProgressModal(false);
    setIsProcessing(false);
    setShowSuccessModal(true);
  }, 2000);
};

  const handleGenerate = () => {
    if (!selectedEmployees.length) {
      toast.warn("No employees selected");
      return;
    }
    setShowConfirmModal(true);
  };

  const handleCancelProcessing = () => {
    setCancelProcessing(true);
    toast.info("Cancelling remaining processing...");
  };

  const departmentList = Array.isArray(getDepartmentList?.result)
    ? [defaultDepartmentOption, ...getDepartmentList.result]
    : [];

  const designationList = Array.isArray(getDesignationList?.result)
    ? [defaultDesignationOption, ...getDesignationList.result]
    : [];

  const locationList = Array.isArray(getLocationList?.result)
    ? [defaultLocationOption, ...getLocationList.result]
    : [];

  const handleSetFilter = (value, source) => {
    setFilter((prev) => ({
      ...prev,
      [source]: value,
    }));
  };

  const handleClearFilters = () => {
    setFilter({
      page_no: 1,
      page_size: 10,
      filter: "",
      department: "",
      designation: "",
      office: "",
      payroll_status: "",
    });
    setSelectedDesignation(null);
    setSelectedDepartment(null);
    setSelectedOffice(null);
    setSelectPayrollStatus(null);
    if (searchRef.current) searchRef.current.value = "";
  };

  return (
    <div className="w-full overflow-x-auto">
      <div className="px-10 py-6">
        <div className="flex justify-between items-center pb-4">
          <div>
            <h2 className="text-lg font-semibold">Review and Generate</h2>
            <p className="text-sm text-gray-500">
              Review and generate pending employee payroll
            </p>
          </div>
        </div>

        <div className="flex items-center justify-between flex-wrap gap-4">
          <div className="flex gap-3 items-center flex-wrap">
            <Select
              value={selectedDesignation}
              onChange={(selected) => {
                setSelectedDesignation(selected);
                handleSetFilter(selected?.value, "designation");
              }}
              placeholder="Designation: All"
              options={designationList.map((i) => ({
                label: i.designation_title,
                value: i.id,
              }))}
              components={{ DropdownIndicator }}
              className="custom-select-container"
            />
            <Select
              value={selectedDepartment}
              onChange={(selected) => {
                setSelectedDepartment(selected);
                handleSetFilter(selected?.value, "department");
              }}
              placeholder="Department: All"
              options={departmentList.map((i) => ({
                label: i.department_name,
                value: i.id,
              }))}
              components={{ DropdownIndicator }}
              className="custom-select-container"
            />
            <Select
              value={selectedOffice}
              onChange={(selected) => {
                setSelectedOffice(selected);
                handleSetFilter(selected?.value, "office");
              }}
              placeholder="Office: All"
              options={locationList.map((i) => ({
                label: i.location_name,
                value: i.id,
              }))}
              components={{ DropdownIndicator }}
              className="custom-select-container"
            />
            {/* {payroll status filter} */}
            {!hasPayrollStatusParam && (
              <Select
                value={selectedPayrollStatus}
                onChange={(selected) => {
                  setSelectPayrollStatus(selected);
                  handleSetFilter(selected?.label, "payroll_status");
                }}
                placeholder="Status: All"
                options={policyPayrollPrcessStatusOptions}
                components={{ DropdownIndicator }}
                className="custom-select-container"
              />
            )}

            {(searchFilter.filter ||
              searchFilter.department ||
              searchFilter.designation ||
              searchFilter.office ||
              searchFilter.payroll_status) && (
              <span
                className="text-blue-600 font-medium cursor-pointer"
                onClick={handleClearFilters}
              >
                Clear Filters
              </span>
            )}
          </div>
          <Search
            eleRef={searchRef}
            onChange={(e) => handleSetFilter(e, "filter")}
            value={searchFilter.filter}
          />
        </div>
      </div>

      {isLoading ? (
        <PageLoader />
      ) : employeeList.length === 0 ? (
        <EmptyState />
      ) : (
        <>
          <EmployeePayrollData
            employeeList={employeeList}
            selectedEmployees={selectedEmployees}
            setSelectedEmployees={setSelectedEmployees}
            year={selectedYear}
            month={selectedMonth}
          />

          <div className="flex justify-end gap-4 mt-6 px-10">
           <button
              className="btn btn--border text-sm font-medium"
              onClick={() => navigate(-1)}
            >
              Back
            </button>
            <button
              className={`btn text-sm font-medium ${
                isProcessing ? "opacity-50 cursor-not-allowed" : ""
              }`}
              onClick={handleGenerate}
              disabled={isProcessing}
            >
              {isProcessing ? "Generating..." : "Generate Bulk Payroll"}
            </button>
          </div>

          <div className="mt-[65px]">
            <Pagination
              page={{
                pageNo: searchFilter.page_no,
                setPageNo: (val) => handleSetFilter(val, "page_no"),
                pageSize: searchFilter.page_size,
                setPageSize: (val) => handleSetFilter(val, "page_size"),
                totalRecords: totalRecords,
                totalPages: totalPages,
              }}
            />
          </div>
        </>
      )}
      {showConfirmModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
          <div className="bg-white rounded-xl shadow-xl p-6 w-full max-w-md">
            <h4 className="text-md font-semibold text-gray-800 mb-4">
              Generate Bulk Payroll
            </h4>
            <p className="text-sm text-gray-600 mb-4">
              Are you sure you want to generate payroll for{" "}
              {selectedEmployees.length} selected employees?
            </p>
            <div className="flex gap-4 justify-end">
              <button
                className="btn btn--border w-full"
                onClick={() => setShowConfirmModal(false)}
              >
                Cancel
              </button>
              <button className="btn w-full" onClick={processPayroll}>
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      {showProgressModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
          <div className="bg-white rounded-xl shadow-xl p-6 w-full max-w-md">
            <div className="flex justify-between items-center mb-4">
              <h4 className="text-md font-semibold text-gray-800">
                Processing Payroll
              </h4>
              <button
                onClick={handleCancelProcessing}
                className="text-sm text-red-500 font-medium hover:underline"
              >
                Cancel
              </button>
            </div>
            <div className="text-sm text-gray-600 mb-2">
              Processed {progress} of {selectedEmployees.length}
            </div>
            <div className="w-full bg-gray-200 rounded-full h-4 overflow-hidden">
              <div
                className="bg-blue-600 h-4 transition-all duration-300"
                style={{
                  width: `${(progress / selectedEmployees.length) * 100}%`,
                }}
              />
            </div>
          </div>
        </div>
      )}
     {showSuccessModal && (
  <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
    <div className="bg-white rounded-xl shadow-lg p-6 w-[400px] text-center">
      <h2 className="text-lg font-semibold text-green-600 mb-4">
        Payroll Processing Summary
      </h2>

      <div className="overflow-x-auto">
        <table className="min-w-full text-sm text-left border rounded-lg overflow-hidden">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-4 py-2 font-semibold text-gray-700">Metric</th>
              <th className="px-4 py-2 font-semibold text-gray-700">Count</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-t">
              <td className="px-4 py-2">Total Selected</td>
              <td className="px-4 py-2">{selectedEmployees.length}</td>
            </tr>
            <tr className="border-t">
              <td className="px-4 py-2 text-green-600">Success</td>
              <td className="px-4 py-2 text-green-600">{successCount}</td>
            </tr>
            <tr className="border-t">
              <td className="px-4 py-2 text-red-600">Failed</td>
              <td className="px-4 py-2 text-red-600">{failureCount}</td>
            </tr>
            <tr className="border-t">
              <td className="px-4 py-2 text-yellow-600">Skipped</td>
              <td className="px-4 py-2 text-yellow-600">{skippedCount}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <button
        className="btn w-full mt-6"
        onClick={() => {
          setShowSuccessModal(false);
          setSelectedEmployees([]);
          setSuccessCount(0);
          setFailureCount(0);
          setSkippedCount(0);
        }}
      >
        Close
      </button>
    </div>
  </div>
)}

    </div>
  );
};

export default EmployeeSalaryPayrollApproval;
